<template>
  <with-title :title="$t('video.views')" :subtitle="videos.length.toString()">
    <video-gallery :videos="videos"></video-gallery>
  </with-title>
</template>

<script>
import { mapState } from 'vuex'
import VideoGallery from '../../../components/product/product-page/video-gallery/VideoGallery'
import WithTitle from '../layouts/WithTitle'

export default {
  name: 'ProductVideos',
  components: {
    VideoGallery,
    WithTitle
  },
  computed: {
    ...mapState({
      videos: state => state.productInfo.productInfo.videos
    })
  }
}
</script>

<style scoped>

</style>
